module.exports = __webpack_public_path__ + "static/headshot-nick-anderson-3x.6cd81e46.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-nick-anderson-3x.png
// module id = 136
// module chunks = 35783957827783 152909308826437